(function($){
  var STEP_RX = /schritt\s+(\d+)\s*(?:von|\/)\s*(\d+)/i;

  function parseSteps(txt){
    var m = (txt||'').match(STEP_RX);
    if(!m) return null;
    var cur = +m[1], total = +m[2];
    if(!total || cur<0 || cur>total) return null;
    return { cur, total, frac: Math.min(1, Math.max(0, cur/total)) };
  }

  function ensureBar($h){
    var $wrap = $h.closest('.headline-wrapper');
    var $bar = $wrap.children('.wizard-progress');
    if ($bar.length) return $bar;
    $bar = $('<div class="wizard-progress" role="progressbar" aria-valuemin="0" aria-valuemax="100"><div class="wizard-progress__fill"></div></div>');
    $wrap.append($bar);
    return $bar;
  }

  function update($h){
    var s = parseSteps($.trim($h.text()));
    var $bar = ensureBar($h);
    if(!s){ $bar.hide(); return; }
    $bar.show()
      .attr({'aria-valuenow': Math.round(s.frac*100), 'aria-label': 'Fortschritt '+s.cur+' von '+s.total})
      .find('.wizard-progress__fill').css('transform','scaleX('+s.frac+')');
  }

  function initOnce($root){
    $root.find('.Form_FormGenerator .headline-wrapper .headline3').each(function(){ update($(this)); });
  }

  // Bei DOM ready UND (optional) nach allen Ressourcen
  $(initOnce.bind(null, $(document)));
  $(window).on('load', function(){ initOnce($(document)); });
})(jQuery);

$(document).ready(function () {
  $(".module-style__fullsize-teaser-background.Text_Link_TextImageLeft .module-content-block .row.hidden-xs .col-sm-6:last-child").each(function () {
    $(this).children().wrapAll("<div class='fullsize-teaser-with-content-wrapper fullsize-teaser-content'></div>");
  });

  $(".module-style__fullsize-teaser-background.Text_Link_TextImageRight .module-content-block .row.hidden-xs .col-sm-6:first-child").each(function () {
    $(this).children().wrapAll("<div class='fullsize-teaser-with-content-wrapper fullsize-teaser-content'></div>");
  });

  $('.content').each(function() {
    var $content = $(this);
    var $inner = $content.find('.content_content-inner');

    if ($inner.length) {
      // Hole die direkten Kinder von .content_content-inner
      var $children = $inner.children();

      // Prüfen, ob alle Kinder .module-style__fullsize-teaser-red-background sind
      var allAreRedTeasers =
        $children.length > 0 &&
        $children.filter(':not(.module-style__fullsize-teaser-background)').length === 0;

      if (allAreRedTeasers) {
        $content.addClass('no-content-padding');
      }
    }
  });
});
